export default __webpack_public_path__ + "static/media/wippy_download_page_google_btn.e26294c6.svg";